import React from "react";

// Small red hand-drawn wavy divider used across sections
const WavyDivider = ({ color = "#A33B35", className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 10"
      className={`wavy-divider ${className}`}
      width="60"
      height="10"
      aria-hidden="true"
    >
      <path
        d="M1 5 C 6 1, 11 9, 16 5 S 26 1, 31 5 S 41 9, 46 5 S 55 1, 59 5"
        fill="none"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default WavyDivider;
